"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormContext = exports.FormContext = void 0;
var react_1 = __importStar(require("react"));
var useTextFieldState_1 = __importDefault(require("../../hooks/useTextFieldState"));
var useFilesState_1 = __importDefault(require("../../hooks/useFilesState"));
var useErrorsState_1 = __importDefault(require("../../hooks/useErrorsState"));
exports.FormContext = (0, react_1.createContext)({});
var useFormContext = function () { return (0, react_1.useContext)(exports.FormContext); };
exports.useFormContext = useFormContext;
var FormProvider = function (props) {
    var _a = (0, useErrorsState_1.default)(), errors = _a[0], setErrors = _a[1], resetErrorsField = _a[2];
    var _b = (0, useTextFieldState_1.default)(), name = _b[0], onChangeName = _b[1];
    var _c = (0, useTextFieldState_1.default)('', resetErrorsField), phoneOrEmail = _c[0], onChangePhoneOrEmail = _c[1];
    var _d = (0, useTextFieldState_1.default)('', resetErrorsField), comment = _d[0], onChangeComment = _d[1];
    var _e = (0, useFilesState_1.default)(), files = _e[0], onAddFile = _e[1], onDeleteFile = _e[2];
    var value = (0, react_1.useMemo)(function () { return ({
        name: name,
        onChangeName: onChangeName,
        comment: comment,
        onChangeComment: onChangeComment,
        phoneOrEmail: phoneOrEmail,
        onChangePhoneOrEmail: onChangePhoneOrEmail,
        files: files,
        onAddFile: onAddFile,
        onDeleteFile: onDeleteFile,
        errors: errors,
        setErrors: setErrors,
        resetErrorsField: resetErrorsField
    }); }, [
        name,
        onChangeName,
        phoneOrEmail,
        onChangePhoneOrEmail,
        comment,
        onChangeComment,
        files,
        onAddFile,
        onDeleteFile,
        errors,
        setErrors,
        resetErrorsField
    ]);
    return (react_1.default.createElement(exports.FormContext.Provider, { value: value }, props.children));
};
exports.default = FormProvider;
